import * as Sentry from '@sentry/nextjs'

import { Button, Form, Input } from '@lockerpm/design'

import blogServices from '@/services/blog'
import { useTranslation } from 'next-i18next'
import { useMemo, useState } from 'react'
import { DEFAULT_BLOG_ID } from '@/config/constants'
import { useRouter } from 'next/router'

export default function FormSubscribe({ isShowPrivacy = false, horizontal = false, blog }) {
  const { t } = useTranslation('blog')
  const [form] = Form.useForm()
  const router = useRouter()

  const [loading, setLoading] = useState(false)
  const [subscribed, setSubscribed] = useState(false)

  const listIds = useMemo(() => {
    if (!blog) {
      return [`${DEFAULT_BLOG_ID[router.locale].default}`]
    }

    const { category } = blog

    if (category && category.includes(280)) {
      return [`${DEFAULT_BLOG_ID[router.locale].password_manager}`]
    }

    if (category && category.includes(281)) {
      return [`${DEFAULT_BLOG_ID[router.locale].secret_manager}`]
    }

    return [`${DEFAULT_BLOG_ID[router.locale].default}`]
  }, [blog, router.locale])

  const onFinish = async (values) => {
    try {
      setLoading(true)
      const data = {
        email: values.email,
        service: 'locker-blog-subscribe',
        subscribed: true,
        list_ids: listIds,
        source_link: window.location.href,
      }
      await blogServices.subscribe(data)
      setSubscribed(true)
    } catch (error) {
      Sentry.captureMessage(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <Form
      form={form}
      onFinish={onFinish}
      name="request-subscribe-blog"
      className="form-subscribe-blog"
    >
      <div className={`${horizontal ? 'flex w-full gap-4' : ''}`}>
        <div className="flex-1">
          <Form.Item
            rules={[
              {
                required: true,
                message: t('validate.input_required', {
                  ns: 'common',
                  field: t('form.email', { ns: 'common' }),
                }),
              },
              {
                type: 'email',
                message: t('validate.invalid', {
                  ns: 'common',
                  field: t('form.email', { ns: 'common' }),
                }),
              },
            ]}
            className="mb-0 w-full"
            name="email"
          >
            <Input
              size="small"
              readOnly={subscribed}
              className="h-11"
              placeholder={t('form.input_email', { ns: 'common' })}
            />
          </Form.Item>
          {isShowPrivacy ? (
            <p className="mt-[6px] mb-4 text-sm text-[##475467]">
              {t('weekly_news.privacy')}{' '}
              <a
                href=""
                className="underline hover:text-primary-HOVER lowercase"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('privacy_policy')}
              </a>
              .
            </p>
          ) : null}
        </div>
        <Form.Item className="mb-0">
          <Button
            size={'large'}
            type="primary"
            loading={loading}
            disabled={subscribed}
            className="text-md font-semibold py-2 h-11 rounded-lg"
            htmlType="submit"
            block
          >
            <span>
              {subscribed
                ? t('button.subscribed', { ns: 'common' })
                : t('button.subscribe', { ns: 'common' })}
            </span>
          </Button>
        </Form.Item>
      </div>
    </Form>
  )
}
